import React from 'react'
import './styles.scss';
import Element from './Element'

const {recircArticles} = window.__STATE__ || {}

export default () => (
    <Element articles={recircArticles} />
)
